interface ValuesMap {
  [key: string]: string
}

export function getSortedValuesByKeys(
  keysArray: string[],
  valuesMap: ValuesMap,
) {
  return keysArray
    .map((key) => ({ key, value: valuesMap[key] })) // Create an array of objects with key-value pairs
    .filter((item) => item.value !== undefined && item.value !== null) // Filter out undefined/null values
    .sort((a, b) => a.value.localeCompare(b.value)) // Sort by the values
    .map((item) => item.value) // Extract and return the sorted values
}
